import type { Editor } from "@tiptap/core";
import type { SelectionBookmark } from "@tiptap/pm/state";

/** A mapped bookmark keeps the insertion anchored during concurrent edits. */
export function insertEntityLink(editor: Editor, bookmark: SelectionBookmark, query: string, title: string, href: string) {
  const target = bookmark.resolve(editor.state.doc);
  const matches = editor.state.doc.textBetween(target.from, target.to) === query;
  const range = matches ? { from: target.from, to: target.to } : { from: target.to, to: target.to };
  return editor.chain().focus().insertContentAt(range, [
    { type: "text", text: title, marks: [{ type: "link", attrs: { href } }] },
    { type: "text", text: " ", marks: [] },
  ]).unsetLink().run();
}
